// src/components/sidebar-widgets/ActivitiesCard.jsx
import React from "react";
import { Box, Typography, IconButton, Divider } from "@mui/material";
import { Eye, Sms, Call } from "iconsax-react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  SIDEBAR_WIDGET_BORDER_COLOR,
  SIDEBAR_WIDGET_CARD_SX,
  SIDEBAR_WIDGET_TITLE_SX,
} from "./sidebarWidgetStyles";

const BORDER = SIDEBAR_WIDGET_BORDER_COLOR;
const MUTED = "#A2ABB4";
const BODY = "#344054";
const PURPLE = "#9C4FFF";
const CARD_BG = "#FFFFFF";

function ActivityRow({
  item,
  showActions = true,
  onView,
  onEmail,
  onCall,
  onMore,
}) {
  return (
    <Box   sx={{ py: 1.5 }}>
      {/* top meta row */}
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.9, minWidth: 0 }}>
          <Eye size={16} color={MUTED} variant="Linear" />
          <Typography sx={{ fontSize: 14, color: MUTED, fontWeight: 400, whiteSpace: "nowrap" }}>
            {item.dateText}
          </Typography>
        </Box>

        {showActions ? (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.25 }}>
            <IconButton
              size="small"
              onClick={() => onEmail?.(item)}
              sx={{
                p: 0.5,
                "&:hover": { backgroundColor: "rgba(156,79,255,0.08)" },
              }}
            >
              <Sms size={16} color={PURPLE} variant="Linear" />
            </IconButton>

            <IconButton
              size="small"
              onClick={() => onCall?.(item)}
              sx={{
                p: 0.5,
                "&:hover": { backgroundColor: "rgba(156,79,255,0.08)" },
              }}
            >
              <Call size={16} color={PURPLE} variant="Linear" />
            </IconButton>

            <IconButton
              size="small"
              onClick={() => onMore?.(item)}
              sx={{
                p: 0.5,
                "&:hover": { backgroundColor: "rgba(156,79,255,0.08)" },
              }}
            >
              <MoreVertIcon sx={{ fontSize: 18, color: PURPLE }} />
            </IconButton>
          </Box>
        ) : (
          <Box sx={{ width: 78 }} />
        )}
      </Box>

      {/* message */}
      <Typography sx={{ fontSize: 14, color: BODY, fontWeight: 400, lineHeight: "24px" }}>
        {item.messageLine1}
      </Typography>
      <Typography sx={{ fontSize: 14, color: BODY, fontWeight: 400, lineHeight: "24px" }}>
        {item.messageLine2}
      </Typography>

      {/* view link */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.75 }}>
        <Typography
          onClick={() => onView?.(item)}
          sx={{
            fontSize: 14,
            color: PURPLE,
            fontWeight: 400,
            cursor: "pointer",
            userSelect: "none",
          }}
        >
          View
        </Typography>
      </Box>
    </Box>
  );
}

export default function ActivitiesCard({
  title = "Activities",
  items = [
    {
      id: "a1",
      dateText: "Jan 9 at 7:26 PM",
      messageLine1: "Candidate olivia.rhye@company.com opened",
      messageLine2: "Re: New Job opportunity in NY",
      showActions: true,
    },
    {
      id: "a2",
      dateText: "Jan 4 at 10:15 AM",
      messageLine1: "Candidate olivia.rhye@company.com opened",
      messageLine2: "Re: New Job opportunity in NY",
      showActions: false,
    },
    {
      id: "a3",
      dateText: "Dec 26 at 4:02 PM",
      messageLine1: "Elke Gallo received an email from the candidate",
      messageLine2: "Olivia Rhye Re: New Event - Olivia Rhye...",
      showActions: true,
    },
  ],
  onView,
  onViewAll,
  onEmail,
  onCall,
  onMore,
  sx = {},
}) {
  return (
    <Box
      sx={{
        ...SIDEBAR_WIDGET_CARD_SX,
        mb: "28px",
        background: CARD_BG,
        ...sx,
      }}
    >
      {/* header */}
      <Box sx={{ px: 4, pt: 4, pb: 2 }}>
        <Typography sx={SIDEBAR_WIDGET_TITLE_SX}>
          {title}
        </Typography>
      </Box>

      {/* list */}
      <Box sx={{ px: 4, pb: 2 }}>
        {items.map((it, idx) => (
          <React.Fragment key={it.id || idx}>
            <ActivityRow
              item={it}
              showActions={!!it.showActions}
              onView={onView}
              onEmail={onEmail}
              onCall={onCall}
              onMore={onMore}
            />
            {idx !== items.length - 1 && <Divider sx={{ borderColor: BORDER }} />}
          </React.Fragment>
        ))}

        {/* footer link */}
        <Box sx={{ pt: 1.25, pb: 1.75, display: "flex", justifyContent: "flex-end" }}>
          <Typography
            onClick={() => onViewAll?.()}
            sx={{
              fontSize: 14,
              color: PURPLE,
              fontWeight: 400,
              cursor: "pointer",
              userSelect: "none",
            }}
          >
            View all Activities
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
